import React from 'react';
import PrimaryButton from './PrimaryButton';
import {emptyState} from '../assets/images/images';

function EmptyState({
  noBtn,
  src,
  body,
  heading,
  buttonText,
  height,
  lottie,
  onClick,
  bodyMaxWidth = '',
  className = 'w-full',
  customBtn,
  maxWidth = '',
  imageHeight,
  imageWidth,
  ...otherProps
}) {
  return (
    <div
      className={`${maxWidth} flex flex-col items-center justify-center m-auto text-center ${className}`}
      style={{
        height: height ? `${height}vh` : '35vh',
      }}
    >
      {lottie ? (
        lottie
      ) : (
        <img src={src || emptyState} alt="" width={124} height={124} />
      )}
      {heading ? (
        <h4 className="mt-2 font-medium text-grey">{heading}</h4>
      ) : null}
      {body ? (
        <p
          className={`mt-2 ${
            customBtn ? 'mb-3' : 'mb-3'
          } text-tiny text-body ${bodyMaxWidth}`}
        >
          {body}
        </p>
      ) : null}

      {customBtn ? (
        customBtn
      ) : !noBtn ? (
        <PrimaryButton
          buttonText={buttonText ?? 'Perform lookup'}
          className="!h-10"
          xPadding="px-[35px]"
          onClick={onClick}
          {...otherProps}
        />
      ) : null}
    </div>
  );
}

export default EmptyState;
